import { effect, inject, Injectable } from '@angular/core';
import { StreamService, TimingTowerService, VideoLayoutService } from '@vbrick/vb-lxp-lib';
import { LivestreamViewService } from './livestream-view.service';

@Injectable({
  providedIn: 'root',
})
export class SelectionCoordinatorService {
  private layoutService = inject(VideoLayoutService);
  private livestreamViewService = inject(LivestreamViewService);
  private timingTowerService = inject(TimingTowerService);
  private streamService = inject(StreamService);

  constructor() {
    this.enforceSelectionLimit();
  }

  public enforceSelectionLimit() {
    effect(() => {
      const maxSelectable = this.layoutService.playerCount();
      const slots = this.livestreamViewService.occupiedSlots();

      const overflow = slots.length - maxSelectable;
      if (overflow <= 0) {
        return;
      }

      const removed = this.livestreamViewService.pruneOldest(overflow);

      for (const slot of removed) {
        switch (slot.type) {
          case 'timing':
            this.timingTowerService.setInactive(slot.id);
            break;
          case 'mainStream':
            this.streamService.isMainStreamSelected.set(false);
            break;
          case 'twitchStream':
            this.streamService.isTwitchStreamSelected.set(false);
            break;
        }
      }
    });
  }
}
